import type { ReactNode } from 'react'
import { KILO } from '../../constants/KILO_THEME'

type BottomSheetProps = {
  open: boolean
  onClose: () => void
  title?: string
  children: ReactNode
  variant?: 'light' | 'dark'
}

const BottomSheet = ({ open, onClose, title, children, variant = 'light' }: BottomSheetProps) => {
  if (!open) return null

  const isDark = variant === 'dark'

  return (
    <div className="fixed inset-0 z-[80] flex flex-col justify-end">
      <button type="button" aria-label="Close" className={`absolute inset-0 ${KILO.overlay}`} onClick={onClose} />
      <div
        className={`relative max-h-[85vh] overflow-y-auto rounded-t-3xl px-4 pb-6 pt-4 shadow-2xl ${
          isDark ? 'border-t border-kilo-border bg-kilo-card text-kilo-text' : 'bg-kilo-card text-kilo-text'
        }`}
      >
        <div className="mx-auto mb-4 h-1 w-12 rounded-full bg-kilo-line" />
        {title ? <h2 className="mb-4 text-lg font-bold tracking-tight text-kilo-text">{title}</h2> : null}
        {children}
      </div>
    </div>
  )
}

export default BottomSheet
